import { ApiService } from 'js/src/client';
import { Toast } from 'js/src/components/common/Toast';
import { setBrandKitsLoading, setTeamBrandKitsCount, storeBrandKits } from 'js/src/data/brand-kits';
import { ImmutableFromJS } from 'js/src/libs/consts';
import { ErrorReporter } from 'js/src/libs/error-reporter';
import type { AppDispatch } from 'js/src/libs/RootState';

export function loadBrandKits() {
    return async (dispatch: AppDispatch): Promise<void> => {
        dispatch(setBrandKitsLoading({ flag: true }));
        try {
            const response = await ApiService.brandKitsList();
            const orderedBrandKitList = response.data.sort(
                (a, b) => (a.name.toLowerCase() > b.name.toLowerCase() && 1) || -1,
            );
            const immutableBrandKits = ImmutableFromJS(orderedBrandKitList);
            dispatch(storeBrandKits({ brandKits: immutableBrandKits }));
        } catch (e: unknown) {
            ErrorReporter.capture(e);
            Toast.error(
                'Something went wrong with loading your brand kits, try refreshing the page.',
            );
        } finally {
            dispatch(setBrandKitsLoading({ flag: false }));
        }
    };
}

export function loadTeamBrandKitsCount() {
    return async (dispatch: AppDispatch): Promise<void> => {
        try {
            const response = await ApiService.brandKitsCountRetrieve();
            dispatch(setTeamBrandKitsCount(response.data.count));
        } catch (e: unknown) {
            ErrorReporter.capture(e);
        }
    };
}
